"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";

/**
 * Hook to detect clicks outside of a component
 * @param handler - Function to call when click outside is detected
 * @returns ref to attach to the element
 */
export function useOutsideClick(handler) {
  const $ = _c(3);
  const ref = useRef(null);
  let t0;
  let t1;
  if ($[0] !== handler) {
    t0 = () => {
      const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          handler();
        }
      };
      const handleEscape = event_0 => {
        if (event_0.key === "Escape") {
          handler();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("touchstart", handleClickOutside);
        document.removeEventListener("keydown", handleEscape);
      };
    };
    t1 = [handler];
    $[0] = handler;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return ref;
}